import { ITransactionFees } from './../../../types/model.types';
import type { RootStore } from '~/stores/root.store';
import { action, computed, observable } from 'mobx';
import {
    TActiveFilesWithRecurring,
    TPaymentsHash,
    TPaymentsSource
} from '~/components/Payments/components/types/payments.types';

type TFeesAsString = { [fee in keyof ITransactionFees]: string };
export class PaymentsUiStore {
    rootStore: RootStore;
    @observable activeRecurringFiles: TActiveFilesWithRecurring;
    @observable monthlyPayments: TPaymentsHash;
    @observable overduePayments: TPaymentsHash;
    @observable paymentsCardSource: TPaymentsSource;
    @observable yearlyPaymentsSum: any;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        this.paymentsCardSource = 'home payments poc';
    }

    private formatFixedFee(feeInCents: number): string {
        if (feeInCents >= 100) {
            const dollars = (feeInCents / 100).toFixed(2);
            return `$${dollars}`;
        } else {
            return `${feeInCents}¢`;
        }
    }

    @action
    updateNumberOfActiveRecurringFiles(
        activeRecurringFilesJson: TActiveFilesWithRecurring
    ) {
        this.activeRecurringFiles = activeRecurringFilesJson;
    }

    @action
    updateMonthlyPayments(paymentsJson: TPaymentsHash) {
        this.monthlyPayments = paymentsJson;
    }

    @action
    updateYearlyPaymentsSum(paymentsJson) {
        this.yearlyPaymentsSum = paymentsJson;
    }

    @action
    updateOverduePayments(paymentsJson) {
        this.overduePayments = paymentsJson;
    }

    @action
    updatePaymentsCardSource(paymentsCardSource) {
        this.paymentsCardSource = paymentsCardSource;
    }

    @computed
    get feesValues(): TFeesAsString {
        const {
            userStore: {
                currUser: {
                    account: { transaction_fees }
                }
            }
        } = this.rootStore;

        return Object.keys(transaction_fees || {}).reduce(
            (feesMap, transactionName: keyof ITransactionFees) => {
                const fee = transaction_fees[transactionName];
                if (!fee.fee_percent && !fee.fee_fixed_in_cents) {
                    return feesMap;
                } else if (!fee.fee_fixed_in_cents) {
                    feesMap[transactionName] = `${fee.fee_percent}%`;
                } else if (!fee.fee_percent) {
                    const fixedFeeInCents = fee.fee_fixed_in_cents;
                    feesMap[transactionName] =
                        this.formatFixedFee(fixedFeeInCents);
                } else {
                    const fixedFeeInCents = fee.fee_fixed_in_cents;
                    feesMap[transactionName] = `${
                        fee.fee_percent
                    }% + ${this.formatFixedFee(fixedFeeInCents)}`;
                }
                return feesMap;
            },
            {} as TFeesAsString
        );
    }

    @computed
    get isCardSourceOneHome(): boolean {
        return this.paymentsCardSource === 'one-home';
    }
}
